<div class="mt-4 w-750px">
  <thera-client-side-list
  class="w-full custom-column-spacing"
  [hideGridLines]="true"
  [columnDefs]="columnDefs"
  [rowData]="rowData">
</thera-client-side-list>
</div>
